/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_DescriptionInputs */

const en_blog_description = /** @type {(inputs: Blog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product updates, guides, and engineering notes from the team.`)
};

const zh_blog_description = /** @type {(inputs: Blog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`来自团队的产品动态、使用指南与工程笔记。`)
};

/**
* | output |
* | --- |
* | "Product updates, guides, and engineering notes from the team." |
*
* @param {Blog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const blog_description = /** @type {((inputs?: Blog_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_description(inputs)
	return zh_blog_description(inputs)
});
export { blog_description as "blog.description" }